import type { ReactNode } from 'react';

import { FilterInDropdown } from '@sorare/core/src/atoms/dropdowns/FilterInDropdown';
import { RadioGroup } from '@sorare/core/src/atoms/inputs/RadioGroup';
import { SelectHeader } from '@sorare/marketplace/src/atoms/SelectHeader';

type Props = {
  name: string;
  header: ReactNode;
  options: { value: string; label: ReactNode }[];
  value: string;
  onChange: (value: string) => void;
};

export const PoolFilterSelect = ({
  name,
  header,
  options,
  value,
  onChange,
}: Props) => {
  const selectedOption = options.find(option => option.value === value);

  return (
    <FilterInDropdown
      buttonSize="small"
      buttonColor="tertiary"
      buttonLabel={selectedOption?.label || header}
    >
      {({ closeDropdown }) => (
        <>
          <SelectHeader>{header}</SelectHeader>
          <RadioGroup
            modalSelect
            name={name}
            options={options}
            value={value}
            onChange={newValue => {
              onChange(newValue);
              closeDropdown();
            }}
          />
        </>
      )}
    </FilterInDropdown>
  );
};
